import React from "react";
import { FOOTER } from "../../../layout/eng/footer";
import { SUBHEADER } from "../../../layout/eng/subheader";
import { EN_Certification } from "../../../parts/eng/intro/certification";
import { Helmet } from "react-helmet";
export const EN_CERTIFICATION = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="intro">
        <EN_Certification />
      </div>
      <FOOTER />
    </main>
  );
};
